export default __webpack_public_path__ + "unity.862e09bb.png";